import useSWR from "swr";

async function fetcher(...urls) {
  const f = (u) =>
    fetch(u).then((r) => {
      if (!r.ok) {
        const error = new Error("An error occurred while fetching the data.");
        error.info = r.json();
        error.status = r.status;
        throw error;
      }
      return r.json();
    });

  if (urls.length > 1) {
    return Promise.all(urls.map(f));
  }
  return f(urls);
}

export default function useFetcher(...url) {
  // Conditional fetching (standard SWR convention): a falsy first key — e.g.
  // useFetcher(enabled ? "/api/..." : null) — skips the request entirely.
  // Every existing caller passes a truthy URL, so behavior is unchanged.
  const { data, error, isLoading, mutate } = useSWR(url[0] ? url : null, fetcher, {
    errorRetryCount: 3,
    errorRetryInterval: 5000,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
      // Auth/not-found errors won't self-heal — surface them so the UI can
      // show an error state instead of retrying (and spinning) forever.
      if (
        error.status === 404 ||
        error.status === 401 ||
        error.status === 403
      ) {
        return;
      }
      // Give transient (5xx/network) errors a few bounded retries, e.g. while a
      // deploy is in flight, then stop so the error can render.
      const maxRetries = config.errorRetryCount ?? 3;
      if (retryCount >= maxRetries) return;
      setTimeout(
        () => revalidate({ retryCount }),
        config.errorRetryInterval ?? 5000,
      );
    },
  });

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
